var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Divider, Grid, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useRetrievePlayerFeed } from "../api/FeedApiProivder";
import { useDeletePlayer, useRetrieveTeamsByPlayerId, useRetrieveUserPlayerPermissions, } from "../ApiProvider";
import { Feed } from "../feed/Feed";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { TeamsCard } from "../teams/TeamsCard";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { playerDisplayName } from "./PlayerDisplayNameLink";
import { PlayerStatsCard } from "./PlayerStatsCard";
import { PlayerView } from "./PlayerView";
export var PlayerPage = function (_a) {
    var player = _a.player, canViewTeams = _a.canViewTeams, canModify = _a.canModify;
    var navigate = useNavigate();
    var _b = __read(React.useState(false), 2), showDelete = _b[0], setShowDelete = _b[1];
    var _c = useRetrieveUserPlayerPermissions({ playerId: player.id }), userPlayerPermissions = _c.data, userPlayerPermissionsIsLoading = _c.isLoading, userPlayerPermissionsError = _c.error;
    var _d = useRetrieveTeamsByPlayerId({ playerId: player.id }), _e = _d.data, teams = _e === void 0 ? [] : _e, teamsIsLoading = _d.isLoading, teamsError = _d.error;
    var teamIds = (teams === null || teams === void 0 ? void 0 : teams.map(function (team) { return team.id; })) || [];
    var mutation = useDeletePlayer({
        id: player.id,
        teamIds: teamIds,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/");
        },
        onError: function (error) {
            console.error("Error deleting player", error);
        },
    });
    var _f = useRetrievePlayerFeed({ player: player, limit: 10 }), feed = _f.data, isFeedLoading = _f.isLoading, feedError = _f.error, fetchNextPage = _f.fetchNextPage, hasNextPage = _f.hasNextPage, isFetchingNextPage = _f.isFetchingNextPage;
    if (userPlayerPermissionsError) {
        return _jsx(ErrorView, { error: userPlayerPermissionsError });
    }
    if ((teamsIsLoading && canViewTeams) ||
        mutation.isLoading ||
        userPlayerPermissionsIsLoading ||
        isFeedLoading) {
        return _jsx(Loading, {});
    }
    if (!player ||
        teamsError ||
        feedError ||
        (!teams && canViewTeams) ||
        !userPlayerPermissions ||
        !feed) {
        return _jsx(ErrorView, { error: teamsError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete player. Please try again." }), _jsx(DeleteDialog, { open: showDelete, onCancel: function () { return setShowDelete(false); }, title: "Delete ".concat(playerDisplayName(player), "?"), onConfirm: function () { return mutation.mutate(); }, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsxs(Grid, { item: true, xs: 10, children: [_jsx(PlayerView, { player: player }), _jsx(Typography, { variant: "body2", fontStyle: "italic", mt: 1, children: player.bio })] }), _jsx(Grid, { item: true, xs: 2, children: player.externalUser && canModify && (_jsxs(Stack, { direction: "row", spacing: 1, children: [_jsx(IconButton, { "aria-label": "edit", children: _jsx(Link, { to: "/external-users/".concat(player.externalUser.id, "/update/"), children: _jsx(EditIcon, {}) }) }), !player.user && (_jsx(IconButton, { "aria-label": "delete", disabled: mutation.isLoading, children: _jsx(DeleteIcon, { onClick: function () {
                                            setShowDelete(true);
                                        } }) }))] })) })] }), _jsx(Divider, { sx: { margin: "20px" } }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, md: 4, children: _jsx(PlayerStatsCard, { player: player, canModify: canModify }) }), _jsxs(Grid, { item: true, xs: 12, md: 5, children: [_jsx(Typography, { variant: "h6", children: "Latest Activity" }), _jsx(Feed, { feed: feed, fetchNextPage: fetchNextPage, hasNextPage: hasNextPage, isFetchingNextPage: isFetchingNextPage })] }), _jsx(Grid, { item: true, xs: 12, md: 3, children: _jsx(TeamsCard, { teams: teams }) })] })] }));
};
